module.exports = __webpack_public_path__ + "static/media/thumnail (2).18f62e32.png";